import React from 'react';
import PropTypes from 'prop-types';
import OneClickSubscribeHOC from '../one_click_subscribe_hoc/one_click_subscribe_hoc';
import EmailSubscribeForm from '../email_subscribe_form/email_subscribe_form';
import './newsletter_subscription.scss';

const NewsletterSubscription = ({
  newsletter,
  isSignedIn = false,
  checkIfSubscribed = true,
  buttonClass = '',
  hideIfSubscribed = true,
}) => {
  return (
    <div
      data-testid='newsletter-subscription'
      className={`text-center newsletter-subscription ${
        newsletter.accent_color ? newsletter.accent_color : 'orange-theme'
      }`}
    >
      {isSignedIn ? (
        <div data-testid='container-one-click-subscribe-button'>
          <OneClickSubscribeHOC
            newsletter={newsletter}
            checkIfSubscribed={checkIfSubscribed}
            hideIfSubscribed={hideIfSubscribed}
          />
        </div>
      ) : (
        <div
          className='container-email-subscribe-form'
          data-testid='container-email-subscribe-form'
        >
          <EmailSubscribeForm
            newsletter={newsletter}
            titlePrefix='Subscribe to '
            buttonClass={buttonClass}
          />
        </div>
      )}
    </div>
  );
};

NewsletterSubscription.propTypes = {
  newsletter: PropTypes.shape({
    id: PropTypes.number.isRequired,
    permalink: PropTypes.string.isRequired,
    icon: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    accent_color: PropTypes.string,
  }),
  isSignedIn: PropTypes.bool,
  checkIfSubscribed: PropTypes.bool,
  buttonClass: PropTypes.string,
  hideIfSubscribed: PropTypes.bool,
};

export default NewsletterSubscription;
